// The embeddable card (embed.html, served as /embed?app=730): a game's
// current players, 24h change, rank and peak, and its last 7 days as a
// sparkline, for other sites to show in an iframe. The whole card links to
// the game's page here.
//
//   ?app=730          the game (required)
//   &theme=dark|light fixed colours; by default it follows the reader's
//
// It's a static page, so it never runs the site Worker; it reads the API from
// the reader's browser as the site does (CORS is open).

import type { AppResponse, HistoryResponse } from "../../../shared/api.ts";
import { appPath } from "../../../shared/site.ts";
import { cardHtml, cardName, embedAppId } from "./card.ts";
import { API } from "../web.ts";

// The app id. (?theme= is embed.html's, set before first paint.)
const params = new URLSearchParams(location.search);

// embed.html's, built with this script.
const card = document.getElementById("card") as HTMLAnchorElement;

function show(html: string): void {
  card.innerHTML = html;
  card.removeAttribute("aria-busy");
}

function render(game: AppResponse, history: HistoryResponse | null): void {
  const name = cardName(game);
  document.title = `${name} player count · steamdata.dev`;
  card.title = `${name} on steamdata.dev`;
  show(cardHtml(game, history));
}

async function load(): Promise<void> {
  const appId = embedAppId(params.get("app"));
  if (!appId) {
    show(`<div class="status">Add <code>?app=</code> and a Steam app id.</div>`);
    return;
  }
  card.href = `${location.origin}${appPath(appId)}`;

  // Both at once. The chart is a nice-to-have: the card stands without it.
  const history = fetch(`${API}/api/apps/${appId}/history?range=7d`)
    .then(async (res) => (res.ok ? ((await res.json()) as HistoryResponse) : null))
    .catch(() => null);
  const res = await fetch(`${API}/api/apps/${appId}`);
  if (!res.ok) {
    show(`<div class="status">${res.status === 404 ? "Game not found." : "Couldn't load player counts."}</div>`);
    return;
  }
  render((await res.json()) as AppResponse, await history);
}

load().catch(() => show(`<div class="status">Couldn't load player counts.</div>`));
